import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const ConfigContext = createContext({
  oktaIssuer: '',
  oktaClientId: '',
  oktaAuthorizeUrl: '',
  oktaEnabled: false,
  loading: true
});

const apiBase = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

export function ConfigProvider({ children }) {
  const [oktaIssuer, setOktaIssuer] = useState(process.env.REACT_APP_OKTA_ISSUER || '');
  const [oktaClientId, setOktaClientId] = useState(process.env.REACT_APP_OKTA_CLIENT_ID || '');
  const [oktaAuthorizeUrl, setOktaAuthorizeUrl] = useState(process.env.REACT_APP_OKTA_AUTHORIZE_URL || '');
  const [oktaEnabled, setOktaEnabled] = useState(!!(process.env.REACT_APP_OKTA_ISSUER && process.env.REACT_APP_OKTA_CLIENT_ID));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${apiBase}/api/config`)
      .then((res) => {
        const data = res.data || {};
        const oktaIss = data.oktaIssuer || process.env.REACT_APP_OKTA_ISSUER || '';
        const oktaCid = data.oktaClientId || process.env.REACT_APP_OKTA_CLIENT_ID || '';
        const oktaAuthUrl = data.oktaAuthorizeUrl || process.env.REACT_APP_OKTA_AUTHORIZE_URL || '';
        const oktaOn = data.oktaEnabled !== undefined ? !!data.oktaEnabled : !!(oktaIss && oktaCid);
        setOktaIssuer(oktaIss);
        setOktaClientId(oktaCid);
        setOktaAuthorizeUrl(oktaAuthUrl);
        setOktaEnabled(oktaOn);
      })
      .catch(() => {
        setOktaIssuer(process.env.REACT_APP_OKTA_ISSUER || '');
        setOktaClientId(process.env.REACT_APP_OKTA_CLIENT_ID || '');
        setOktaAuthorizeUrl(process.env.REACT_APP_OKTA_AUTHORIZE_URL || '');
        setOktaEnabled(!!(process.env.REACT_APP_OKTA_ISSUER && process.env.REACT_APP_OKTA_CLIENT_ID));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <ConfigContext.Provider value={{ oktaIssuer, oktaClientId, oktaAuthorizeUrl, oktaEnabled, loading }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
